import React, { useState, useEffect } from "react";
import { injectIntl } from "react-intl";
import { Box, Stack, InputAdornment, IconButton, FormLabel } from "@mui/material";
import { Icon } from "@iconify/react";
import CommonButton from "@/views/CommonComponent/CommonButton";
import ComfirmDialog from "@/views/CommonComponent/ComfirmDialog";
import {
  InfoBox,
  SignInContentsBox,
  InputField,
} from "../SignIn/Styled/SignInStyled";
import { inject, observer } from "mobx-react";
import { useHistory, useLocation } from "react-router-dom";
import {
  disConnectPokoro
} from "../../nativebridge/JsToNative";
import {
  NativeToJsBridge,
  NativeToJsEventName,
  getPlatform,
} from "../../nativebridge/NativeToJs";
import { usePenStatus } from "../../nativebridge/PenStatus";
import CommonLoading from "@/views/CommonComponent/CommonLoading";
import TitleBox from "../CommonComponent/TitleBox";
import { useToast } from '../../components/useToast';

function NewWifiConnect(props) {
  const { intl } = props;
  const history = useHistory();
  const location = useLocation();

  const [isPasswordVisible, setIsPasswordVisible] = useState(false);
  const [wifiPassword, setWifiPassword] = useState("");
  const [wifiName, setWifiName] = useState("");

  const [disconnect, setDisconnect] = React.useState(false);
  const { globalPenStatus, setGlobalPenStatus } = usePenStatus();
  const [wifiConnected, setWifiConnected] = React.useState(false);
  
  const [loading, setLoading] = React.useState(false);

  const { showErrorToast, showSuccessToast } = useToast();

  const handleBack = () => {
    history.goBack();
  };

  const handleWifiConnect = () => {
    if (!wifiName || !wifiPassword) {
      showErrorToast(intl.formatMessage({ id: "wifi_fail_msg" })); // 연결에 실패했습니다. 비밀번호 확인 후 다시 연결해주세요.
      return;
    }
    setLoading(true);
    // 테스트를 위해 임시로 성공 케이스 추가
    setTimeout(() => {
      onDeviceWifiConnected();
    }, 3000);

    // wifiInputPassword(wifiName, wifiPassword);// 와이파이 연결시도 
  };

  const handleTogglePasswordVisibility = () => {
    setIsPasswordVisible((prev) => !prev);
  };

  const isButtonDisabled = () => {
    // Logic to determine if button should be disabled
    return (!wifiPassword && !wifiName); // Example condition
  };

  const onDeviceDisConnected = () => {
    setGlobalPenStatus((prevStatus) => ({
      ...prevStatus,
      isConnect: false,
    }));
    setDisconnect(true);
    showErrorToast(intl.formatMessage({ id: "disconnect_dialog_Title" })); // 연결이 해제되었습니다.

    // 토스트 메시지를 3초 동안 보여준 후 설정 페이지로 이동
    setTimeout(() => {
      history.push('/setting');
    }, 3000);
  };

  const onDeviceWifiConnected = () => {
    setLoading(false);
    setWifiConnected(true);
    console.log("WifiConnect ===onDeviceWifiConnected");
  };

  const handleWifiSuccessClickConfirm = () => {
    disConnectPokoro();
    setGlobalPenStatus((prevStatus) => ({
      ...prevStatus,
      isConnect: false,
    }));
    setWifiConnected(false);
    console.log("NewWifiConnect ===handleWifiSuccessClickConfirm");
    history.push('/home');
  };


  

  const onDeviceWifiConnectFail = (msg) => {
    setLoading(false);
    console.log(`WifiConnect ===onDeviceWifiConnectFail : ${msg}`);

    if (msg.msg === '0') {
      showErrorToast(<span style={{ whiteSpace: "pre-line" }}>
        {intl.formatMessage({ id: "wifi_fail_msg" })} {/* 연결에 실패했습니다. 비밀번호 확인 후 다시 연결해주세요. */}
      </span>);
    } else {
      showErrorToast(<span style={{ whiteSpace: "pre-line" }}>
        {intl.formatMessage({ id: "wifi_fail_msg2" })} {/* 알 수 없는 오류로 인해 연결에 실패했습니다. 다시 연결해주세요. */}
      </span>);
    }
  };

  useEffect(() => {

    //NativeToJsEventOnDeviceDisConnected
    NativeToJsBridge.instance.addEventListener(
      NativeToJsEventName.onDeviceDisConnected,
      async (event) => {
        onDeviceDisConnected();
      }
    );


    //NativeToJsEventOnDeviceWifiConnected
    NativeToJsBridge.instance.addEventListener(
      NativeToJsEventName.onDeviceWifiConnected,
      async (event) => {
        onDeviceWifiConnected();
      }
    );
    //NativeToJsEventOnDeviceWifiConnectFail
    NativeToJsBridge.instance.addEventListener(
      NativeToJsEventName.onDeviceWifiConnectFail,
      async (event) => {
        const jsonStr = event;
        onDeviceWifiConnectFail(jsonStr);
      }
    );
    // 컴포넌트 언마운트 시 이벤트 제거
    return () => {
      NativeToJsBridge.instance.removeEventListener(
        NativeToJsEventName.onDeviceConnected
      );
      NativeToJsBridge.instance.removeEventListener(
        NativeToJsEventName.onDeviceWifiConnected
      );
      NativeToJsBridge.instance.removeEventListener(
        NativeToJsEventName.onDeviceWifiConnectFail
      );
    };
  }, []);

  return (
    <Stack width='100%'>
      {loading && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            backgroundColor: "rgba(255, 255, 255, 0.8)",
            zIndex: 9999,
          }}
        >
          <CommonLoading text={intl.formatMessage({ id: "connecting_to_wifi" })} />
        </div>
      )}
      <ComfirmDialog
        open={wifiConnected}
        title={intl.formatMessage({ id: "wifi_connected" })}
        contents={intl.formatMessage({ id: "wifi_connection_success_msg" })}
        buttonText={intl.formatMessage({ id: "dialog_confirmButton" })}
        onClick={handleWifiSuccessClickConfirm}
      />

      <TitleBox
        title={intl.formatMessage({ id: "add_new_wifi" })} /* 새로운 Wi-Fi 추가 */
        subtitle={intl.formatMessage({ id: "new_wifi_txt" })} /* 포코로에 연결할 Wi-Fi 정보를 직접 입력해주세요. */
        onBack={handleBack}
      />
      <SignInContentsBox className="modify">
        <InfoBox mt={2} sx={{ gap: 2 }}>
          <Box width='100%' maxWidth='500px'>
            <FormLabel>
              {intl.formatMessage({ id: "new_wifi_name" })} {/* 새로운 Wi-Fi 이름 */}
            </FormLabel>
            <InputField
              placeholder={intl.formatMessage({ id: "new_wifi_name_txt" })} /* Wi-Fi 이름을 입력해주세요. */
              autoComplete="off"
              value={wifiName}
              onChange={(e) => setWifiName(e.target.value)}
              InputLabelProps={{
                shrink: true,
                sx: {
                  "& .MuiInputLabel-asterisk": { color: "#FF0000" },
                },
              }}
            />
          </Box>
          <Box width='100%' maxWidth='500px'>
            <FormLabel>
              {intl.formatMessage({ id: "password" })} {/* 비밀번호 */}
            </FormLabel>
            <InputField
              type={isPasswordVisible ? "text" : "password"}
              placeholder={intl.formatMessage({ id: "new_wifi_pw_txt" })} /* Wi-Fi의 비밀번호를 입력해주세요. */
              autoComplete="off"
              value={wifiPassword}
              onChange={(e) => setWifiPassword(e.target.value)}
              InputLabelProps={{
                shrink: true,
                sx: {
                  "& .MuiInputLabel-asterisk": { color: "#FF0000" },
                },
              }}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      onClick={handleTogglePasswordVisibility}
                      edge="end"
                    >
                      {isPasswordVisible ? <Icon icon="ri:eye-line" /> : <Icon icon="ri:eye-off-line" />}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
          </Box>
        </InfoBox>
        <CommonButton
          text={intl.formatMessage({ id: "wifi_connection" })} /* Wi-Fi 연결 */
          background={"#FDD751"}
          color={"#333"}
          disabled={isButtonDisabled()}
          onClick={handleWifiConnect}
        />
      </SignInContentsBox>
    </Stack>
  );
}

export default injectIntl(inject("authStore", "userStore")(observer(NewWifiConnect)));
